// Weekly lessons from the first date to the last, both counted: 10 Oct to
// 19 Dec 2026 is 11 Saturdays. (Dividing the gap by seven and rounding, as
// the form used to, gave 10.) Empty when either date is missing or the end is
// before the start.
export const lessonWeeks = (start, end) => {
  if (!start || !end) return "";
  const days = Math.round((new Date(end) - new Date(start)) / 86400000);
  return days < 0 ? "" : Math.floor(days / 7) + 1;
};
